import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import _ from "lodash";

import { Checkbox } from "../../../../../components/checkbox/Checkbox";

import "./scheduleDays.scss";

const DAYS = {
  MO: "mon",
  TU: "tue",
  WE: "wed",
  TH: "thu",
  FR: "fri",
  SA: "sat",
  SU: "sun",
};

export const ScheduleDays = (props) => {
  const intl = useIntl();

  const { days, selectedDays, onDaysChange, showFullNames = false } = props;
  const isChecked = (day) => _.includes(selectedDays, day);

  return (
    <fieldset className={"schedule-days"}>
      <legend>
        <FormattedMessage id={"days"} />
      </legend>
      {_.map(days, (day) => (
        <Checkbox
          id={`weekday_${day}`}
          key={day}
          name={day}
          aria-label={intl.formatMessage({ id: day })}
          onChange={onDaysChange}
          checked={isChecked(day)}
          label={<FormattedMessage id={showFullNames ? day : DAYS[day]} />}
        />
      ))}
    </fieldset>
  );
};
